import { CdkConnectedOverlay, ConnectedPosition } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { DropdownBaseComponent } from '../dropdown-base/dropdown-base.component';
import { ButtonType } from '@anecdotes/design-system/buttons';

@Component({
  selector: 'app-three-dots-menu',
  templateUrl: './three-dots-menu.component.html',
  styleUrls: ['./three-dots-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ThreeDotsMenuComponent extends DropdownBaseComponent {
  @ViewChild(CdkConnectedOverlay, { static: true })
  private cdkConnectedOverlay: CdkConnectedOverlay;

  /**
   * The value of this attribute is used by auto-tests so that they can detect overlay panel
   * that is rendered outside of that component
   */
  @HostBinding('attr.aria-controls')
  private get instanceId(): string {
    return this.cdkConnectedOverlay?.overlayRef?.overlayElement.id;
  }

  @HostBinding('class')
  private get classes(): string {
    return `${this.dotsType} ${this.menuSize}`;
  }

  @Input()
  loading: boolean;

  @Input()
  saveButtonSizeDuringLoading = false;

  @Input()
  dotsType: 'dark' | 'light' = 'dark';

  @Input()
  listWidth: 'small' | 'medium' = 'medium';

  @Input()
  menuSize: 'default' | 'small' = 'default';

  @HostBinding('class.disabled')
  @Input()
  disabled: boolean;

  @Input()
  overlayPosition?: ConnectedPosition;

  @Input()
  buttonType: ButtonType = 'secondary';

  @Input()
  buttonSvgIconPath?: string;

  @Input()
  menuText: string;

  constructor(cd: ChangeDetectorRef) {
    super(cd);
  }

  open(): void {
    if (this.disabled || this.isOpen) {
      return;
    }

    this.isOpen = true;
    this.cd.markForCheck();
    this.cd.detectChanges();
  }

  @HostListener('document:keydown.escape')
  close(): void {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.cd.detectChanges();
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();

    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}
